export const INIT_FORM_DATA = 'INIT_FORM_DATA'
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA'
export const FLUSH_DATA = 'FLUSH_DATA'
export const UPDATE_MODULE = 'UPDATE_MODULE'
export const REMOVE_MODULE = 'REMOVE_MODULE'
